import { useEffect } from "react";

let lockCount = 0;
let savedHtmlOverflow = "";
let savedBodyOverflow = "";

function applyOverflow(el: HTMLElement, value: string) {
  if (value) {
    el.style.overflow = value;
  } else {
    el.style.removeProperty("overflow");
  }
}

function lockPageScroll() {
  if (lockCount === 0) {
    const html = document.documentElement;
    savedHtmlOverflow = html.style.overflow;
    savedBodyOverflow = document.body.style.overflow;
    html.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }
  lockCount += 1;
}

function unlockPageScroll() {
  if (lockCount <= 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    applyOverflow(document.documentElement, savedHtmlOverflow);
    applyOverflow(document.body, savedBodyOverflow);
  }
}

/**
 * Prevents background page scroll while Send / Receive / Portal modals are open.
 * Locks both `html` and `body` (index.css sets overflow-x on html as the scroll container).
 * Ref-counted so stacked modals restore page scroll only when all are closed.
 */
export function useBodyScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;

    lockPageScroll();
    return () => {
      unlockPageScroll();
    };
  }, [active]);
}
